export const invertMap = <TKey, TValue>(
  map: Map<TKey, TValue>,
): Map<TValue, TKey> => {
  const resultMap = new Map<TValue, TKey>();
  map.forEach((value, key) => resultMap.set(value, key));
  return resultMap;
};
